<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter
                    :title="'指定聯絡人作業'"
                >
                    <template #before>
                        <ul
                            v-for="(data, index) in beforeData.assignContactList"
                            class="space-y-2 pb-2 md:min-h-[2rem]"
                        >
                            <template v-if="isEmptyData(data)">
                            </template>
                            <template v-else>
                                <p>{{ `聯絡人${index + 1}資訊` }}</p>
                                <li v-if="data.name">
                                    姓名: {{ data.name }}
                                </li>
                                <li v-if="data.id">
                                    身分證號碼/居留證統一證號: {{ data.id }}
                                </li>
                                <li v-if="data.relation">
                                    與要保人關係: {{ relationArray?.find(p => p.value === data.relation)?.label }}
                                </li>
                                <li v-if="data.mobile">
                                    行動電話: {{ data.mobileCountry === '886' ? '' : data.mobileCountry }}
                                    {{ data.mobile }}
                                </li>
                                <li
                                    v-if="data.email"
                                    class="break-all"
                                >
                                    E-mail: {{ data.email }}
                                </li>
                            </template>
                        </ul>
                    </template>
                    <template #after>
                        <p>{{ afterData.selected === 'A' ? '新增/變更指定聯絡人' : '終止約定指定聯絡人' }}</p>
                        <ul
                            v-for="(data, index) in afterData.assignContactList"
                            class="space-y-2 pb-2 md:min-h-[2rem]"
                        >
                            <template v-if="isEmptyData(data)">
                            </template>
                            <template v-else>
                                <p>{{ `聯絡人${index + 1}資訊` }}</p>
                                <li v-if="data.name">
                                    姓名: {{ data.name }}
                                </li>
                                <li v-if="data.id">
                                    身分證號碼/居留證統一證號: {{ data.id }}
                                </li>
                                <li v-if="data.relation">
                                    與要保人關係: {{ relationArray?.find(p => p.value === data.relation)?.label }}
                                </li>
                                <li v-if="data.mobile">
                                    行動電話: {{ data.mobileCountry === '886' ? '' : data.mobileCountry }}
                                    {{ data.mobile }}
                                </li>
                                <li
                                    v-if="data.email"
                                    class="break-all"
                                >
                                    E-mail: {{ data.email }}
                                </li>
                            </template>
                        </ul>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>
<script>
import { toRef, computed, ref } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'BAData',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter,
    },
    props: {
        result: {
            type: Object,
            required: true,
        },
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const code = ref('BA');
        // 被保人區塊資訊 insuredInfo // 收費區塊資訊 chargeInfo
        // 要保人區塊資訊 applicantInfo // 要保人行動電話 mobile // 要保人Email email
        const data = toRef(props, 'result');

        const beforeData = computed(() => {
            return data.value.before;
        });
        const afterData = computed(() => {
            return data.value.after;
        });

        const removeService = () => {
            emit('removeService', code.value);
        };
        const fieldNameList = {
            id: '身分證',
            name: '姓名',
            relation: '關係',
            mobileCountry: '國碼',
            mobile: '行動電話',
            email: 'E-mail',
        };
        const isEmptyData = (item) => {
            const i = Object.assign({}, item);
            const keys = Object.keys(fieldNameList);
            let dataList = keys.map(key => {
                return i[key];
            });
            dataList = dataList.filter(j => j);
            let hasData = '';
            if (i.id === 'mobile') {
                hasData = Object.values(dataList).join('').trim() === '886';
            } else {
                hasData = Object.values(dataList).join('').trim() === '';
            }
            return hasData;
        };
        const relationArray = ref([
            {
                label: '配偶',
                value: '1',
            },
            {
                label: '父母',
                value: '2',
            },
            {
                label: '子女',
                value: '3',
            },
            {
                label: '兄弟姊妹',
                value: '4',
            },
            {
                label: '(外)祖孫',
                value: '5',
            },
            {
                label: '其他',
                value: '6',
            },
        ]);
        return {
            removeService,
            code,
            beforeData,
            afterData,
            isEmptyData,
            relationArray
        };
    },
};
</script>
